import { useState } from "react"
import { Box, Stack } from "@mui/material"

export function LockButton({...params}){

    let handleLockClick = params.handleLockClick
    let title = params.title
    let stateObject = params.stateObject

    let [lockButtonState, setLockButtonState] = useState('default')


    let lockPaths = {
        default: "/icons/icons-shared/icon-lock-default.svg",
        edited: "/icons/icons-shared/icon-lock-edited.svg",
        hover: "/icons/icons-shared/icon-lock-hover.svg",
        uneditable: "/icons/icons-shared/icon-lock-uneditable.svg",
    }

    let unlockPaths = {
        default: "/icons/icons-shared/icon-unlock-default.svg",
        edited: "/icons/icons-shared/icon-unlock-edited.svg",
        hover: "/icons/icons-shared/icon-unlock-hover.svg",
    }

    const handleButtonHover = (event) => {
        event.preventDefault()
        setLockButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setLockButtonState('default')
    }


    let imagePath = ''
    if (stateObject[title].lockState){
        if (lockButtonState === 'hover'){imagePath = lockPaths.hover}
        else if (stateObject[title].updatedState && lockButtonState !== 'hover'){imagePath = lockPaths.edited /*green lock*/}
        else if (!stateObject[title].updatedState && lockButtonState !== 'hover'){imagePath = lockPaths.default /*gray lock*/}
    }

    else if (!stateObject[title.lockState]){
        if (lockButtonState === 'hover'){imagePath = unlockPaths.hover}
        else if (stateObject[title].updatedState && lockButtonState !== 'hover'){imagePath = unlockPaths.edited/*green unlock*/}
        else if (!stateObject[title].updatedState && lockButtonState !== 'hover'){imagePath = unlockPaths.default /*blue unlock*/}
    }


    return (
        <Stack direction={'column'} justifyContent={'center'} zIndex={9}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onMouseDown={(event) => handleLockClick(event)}>

            <Box component="img" src={imagePath} width={'20px'} height={'23.7px'} className={"LockButton"}/>
        </Stack>
    )
}
